import { Chip } from '@otp/ui';
import { useTranslation } from 'react-i18next';
import { LmsCurriculumUserStatus } from 'src/graphql/generated/graphql';

export const CurriculumStatusColumn = ({
  status,
  progress,
}: {
  status?: LmsCurriculumUserStatus | null;
  progress?: number | null;
}) => {
  const { t } = useTranslation(undefined, {
    keyPrefix: 'common.status',
  });

  switch (status) {
    case LmsCurriculumUserStatus.Completed:
      return <Chip label={t('completed')} color="success" />;
    case LmsCurriculumUserStatus.InProgress:
      return (
        <Chip
          label={`${t('in-progress')}${progress ? ` (${progress}%)` : ''}`}
          color="primary"
        />
      );
    case LmsCurriculumUserStatus.Assigned:
      return <Chip label={t('registered')} color="warning" />;
    case LmsCurriculumUserStatus.Overdue:
      return <Chip label={t('overdue')} color="error" />;
    default:
      return <Chip label={t('available')} color="warning" />;
  }
};
